import router from '../router';
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token') || null;
    // if (to.matched.some(record => record.meta.requiresAuth)) {
        // if (!token && to.name !== 'login') {
        //     next({ name: 'login' })
        // } else if(token && to.name !== 'login'){

        // }
        // else{
        //     window.scrollTo(0, 0);
        //     next();
        // }
        if(!token){
            if(to.name !== 'login'){
                next({ name: 'login' })
            }else{
                window.scrollTo(0, 0);
                next();
            }
        }else{
            if(to.name === 'login'){
                next({ name: 'dashboard' })
            }else{
                window.scrollTo(0, 0);
                next();
            }

        }
        // else {
            // let user = JSON.parse(localStorage.getItem('user'))
        //     let userRole = localStorage.getItem('userType');
        //     userRole = userRole.split(',');
        //     if (to.matched.some(record => record.meta.isAdmin)) {
        //         if (userRole.includes('ROLE_ADMIN')) {
        //             next()
        //         } else {
        //             next({ name: 'adminReportsPageRoute' })
        //         }
        //     } else if (to.matched.some(record => record.meta.isSuperAdmin)) {
        //         if (userRole.includes('ROLE_SUPER_ADMIN')) {
        //             next()
        //         } else {
        //             next({ name: 'workDeskPageRoute' })
        //         }
        //     } else {
        //         next()
        //     }
        // }
    // } else if (to.matched.some(record => record.meta.guest)) {
    //     if (localStorage.getItem('jwt') == null) {
    //         next()
    //     } else {
    //         next({ name: 'workDeskPageRoute' })
    //     }
    // } else {
    //     next()
    // }
})